import { useEffect, useState } from 'react';

import type { NetworkState } from '@/adapters/network/types';
import { networkAdapter } from '@/adapters/network';

interface NetworkStatus {
  isConnected: boolean;
  networkType: NetworkState['type'];
}

export const useNetworkStatus = (): NetworkStatus => {
  const [status, setStatus] = useState<NetworkStatus>({
    isConnected: true,
    networkType: 'unknown',
  });

  useEffect(() => {
    networkAdapter.getNetworkState().then((state) => {
      setStatus({ isConnected: state.isConnected, networkType: state.type });
    });

    const unsubscribe = networkAdapter.addEventListener((state) => {
      setStatus({ isConnected: state.isConnected, networkType: state.type });
    });

    return unsubscribe;
  }, []);

  return status;
};
